import axios from "axios";
import { toast } from "react-toastify";
import { getUserDetails } from "../utils/utils";

const API_BASE_URL = `${process.env.REACT_APP_BASE_URL}`;
const apiService = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000, // Set timeout as per your requirement
  headers: {
    "Content-Type": "application/json",
  },
});

function logInRedirect() {
  localStorage.clear();
  window.location.href = "/";
}

// Function to handle API errors and display toast messages
const handleApiError = (error) => {
  if (error && error?.response) {
    const { data } = error.response;
    toast.error(
      data.message === "User is not available or disablled"
        ? "Email or password is incorrect. Please try again."
        : data.message || "Bad Request"
    );
    if (data.message === "Unauthorized") {
      logInRedirect();
    }
  } else if (error && error?.request) {
    // The request was made but no response was received
    toast.error("No response received from server");
  } else {
    // Something happened in setting up the request that triggered an Error
    toast.error("Error in request setup");
  }
};

// Function to make HTTP requests with error handling and dispatching loading action
const makeHttpRequest = async (method, endpoint, requestData) => {
  if (
    endpoint !== "/user/checkAuth" &&
    endpoint !== "/user/sendForgetPassword"
  ) {
    const { token } = getUserDetails();
    apiService.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
  try {
    let response;
    switch (method.toLowerCase()) {
      case "get":
        response = await apiService.get(endpoint);
        break;
      case "post":
        response = await apiService.post(endpoint, requestData);
        break;
      case "put":
        response = await apiService.put(endpoint, requestData);
        break;
      case "delete":
        response = await apiService.delete(endpoint);
        break;
      // Add other HTTP methods as needed
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
    return response.data;
  } catch (error) {
    handleApiError(error);
    // throw error;
  }
};

// API service function for GET requests
export const GetApi = async (endpoint) => {
  return makeHttpRequest("get", endpoint);
};

// API service function for POST requests
export const PostApi = async (endpoint, requestData) => {
  return makeHttpRequest("post", endpoint, requestData);
};

// API service function for PUT requests
export const PutApi = async (endpoint, requestData) => {
  return makeHttpRequest("put", endpoint, requestData);
};

// API service function for DELETE requests
export const DeleteApi = async (endpoint) => {
  return makeHttpRequest("delete", endpoint);
};

export default apiService;
